import React from "react";

import "./About.scss";

export const About: React.FC = () => (
  <div className="infoModalContent infoModalContent--about">
    <section className="aboutText">
      <h2>About</h2>
      <p>
        808303.studio is a new online music creation platform created by Yuri
        Suzuki, the Design Museum and Roland, which features Roland’s innovative Step Sequencer
        technique, as well as emulating the sound of the original TR-808 drum
        machine and TB-303 bass synthesiser.
      </p>
      <p>
        It is a professional sounding online musical interface, which records
        your masterpieces and allows you to share your creations through social
        media, messaging and also as a download.
      </p>
      <div className="aboutShareButtons">
        <a
          className="button button--facebook"
          href="https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2F808303.studio"
          target="_blank"
          rel="noopener noreferrer"
        >
          Facebook
        </a>
        <a
          className="button button--twitter"
          href="https://twitter.com/intent/tweet?url=https%3A%2F%2F808303.studio&amp;text=Emulate%20the%20sound%20of%20the%20original%20TR-808%20drum%20machine%20and%20TB-303%20bass%20synthesiser%20in%20the%20music%20creation%20platform%20from%20Yuri%20Suzuki%20and%20Roland."
          target="_blank"
          rel="noopener noreferrer"
        >
          Twitter
        </a>
      </div>
    </section>
    <section className="aboutVideo">
      <h2>
        A Guy
        <br /> Called Gerald
      </h2>
      <div className="video">
        <iframe
          title="Vimeo"
          src="https://player.vimeo.com/video/465077390?autoplay=1&color=ff5a00&title=0&byline=0&portrait=0"
          {...({ allow: "fullscreen" } as any)}
          allowFullScreen
        ></iframe>
      </div>
      <div className="videoCaption">
        <p>
          A Guy Called Gerald, who is a master of the original 808 and 303,
          gives a thorough demonstration of the 8083030.studio in action. He
          demonstrates the versatility of the two instruments and how they
          influence one another. In this fun and informal explanation, you too
          will learn how to make infectious grooves, acid bass lines and find
          your own voice with the 808303.studio
        </p>
      </div>
    </section>
  </div>
);
